import React from "react";
import "./Plan_Purchase_step_fourth.css";

function Plan_Purchase_step_fourth({data,val,insurance}) {
console.log(insurance,' cookies');
const dob = new Date(data?.dob); // e.g., "1990-05-10"
const coverTillAge = insurance?.cover_till_age; // e.g., 65

const today = new Date();

// Calculate coverage end date
const coverEndDate = new Date(dob);
coverEndDate.setFullYear(dob.getFullYear() + coverTillAge);

// Difference from today to coverage end date
const diffTime = coverEndDate - today;
const diffYears = Math.floor(diffTime / (1000 * 60 * 60 * 24 * 365.25));


  return (
    <div className="Plan_Purchase_step_fourth">
      {/* Personal Details */}
      <div className="Plan_Purchase_step_fourth_holder">
        <div className="header">
          Personal Details
          <div className="divider"></div>
        </div>
        <div className="details-grid">
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="field_holder">
                <p className="label">Name</p>
                <p className="value">{val?.name}</p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="field_holder">
                <p className="label">Email</p>
                <p className="value">{val?.email}</p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="field_holder">
                <p className="label">Annual Income</p>
                <p className="value">{val?.annual_income}</p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="field_holder">
                <p className="label">Occupation</p>
                <p className="value">{val?.occupation?.value}</p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="field_holder">
                <p className="label">Education</p>
                <p className="value">{val?.qualification?.value}</p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="field_holder">
                <p className="label">Pin Code</p>
                <p className="value">{val?.pincode}</p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="field_holder">
                <p className="label">City</p>
                <p className="value">{val?.city}</p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="field_holder">
                <p className="label">Nationality</p>
                <p className="value">{val?.nationality_id?.label}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Profile Details */}
      <div className="Plan_Purchase_step_fourth_holder">
        <div className="header">
          Profile Details
          <div className="divider"></div>
        </div>
        <div className="details-grid">
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="field_holder">
                <p className="label">Gender</p>
                <p className="value">{data?.gender}</p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="field_holder">
                <p className="label">Date of Birth</p>
                <p className="value">{data?.dob}</p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="field_holder">
                <p className="label">Tobacco User</p>
                <p className="value">{data?.smoke_status===1?"Yes":"No"}</p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="field_holder">
                <p className="label">Phone Number</p>
                <p className="value">{data?.contact_no
                }</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*    Plan Details  */}
      <div className="Plan_Purchase_step_fourth_holder">
        <div className="header">
          Plan Details
          <div className="divider"></div>
        </div>
        <div className="details-grid">
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="field_holder">
                <p className="label">Life Cover</p>
                <p className="value">₹{insurance?.life_cover} Lacs</p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="field_holder">
                <p className="label">Cover Till Age</p>
                <p className="value">{insurance?.cover_till_age} Years</p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="field_holder">
                <p className="label">Pay for</p>
                <p className="value">{diffYears} Years</p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="field_holder">
                <p className="label">Mode of premium payment</p>
                <p className="value">Monthly</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*    Rider Details  */}
      {/* <div className="Plan_Purchase_step_fourth_holder">
        <div className="header">
          Rider Details
          <div className="divider"></div>
        </div>
        <div className="details-grid">
          <div className="row">
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="field_holder">
                <p className="label">Additional Death Benefit (ADB)</p>
                <p className="value">
                  <strong>Premium value:</strong> ₹ 122
                </p>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="field_holder">
                <p className="label">Accidental Total & Permanent Disability</p>
                <p className="value">
                  <strong>Premium Value:</strong> ₹ 122
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
}

export default Plan_Purchase_step_fourth;
